module.exports = __webpack_public_path__ + "media/images/recruit/recruitmentlist/arrow-white-dc1e9516a4ef7046559670705673d892.svg";